import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        La majstro brila, senriproĉa,<br/>
        Ŝi kreas rimojn kun rapid’<br/>
        Ne per la ŝvitlabor’ pioĉa,<br/>
        Sed elegante, kun la rid’.
      </p>

      <p class="poem-block mb-3">
        La tuta viv’ en poezio,<br/>
        Poemoj ŝprucas el la kor’.<br/>
        Ŝi kiel bela papilio<br/>
        Alportas ĉarmon de la flor’,
      </p>

      <p class="poem-block mb-3">
        Sed same kiel ĉe abelo<br/>
        Aperas ankaŭ la mielo:<br/>
        Belec’ kaj rav’ de fantazi’<br/>
        El la ĝarden’ de poezi’,
      </p>

      <p class="poem-block mb-3">
        Ĝarden’ abunda, multkolora,<br/>
        Kreita de l’ talento ora<br/>
        De nia jubileantin’.<br/>
        Pro ĝi ni dankas, Lunjo, vin!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Al la jubileo de Ludmila Novikova'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;